import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import moment from "moment";

import UserTeacherTimetableBody from "./UserTeacherTimetableBody";
import { useStyles } from "../UserTimetable.css";
import { week } from "../../../../Components/Data/Weeks";

class UserTeacherTimetable extends Component {
  constructor(props) {
    super(props);
    this.state = { day: week[moment(new Date()).day()] };
  }

  render() {
    const { classes, times } = this.props;
    let sundayTable = times.filter((data) => data.weekName === "Sunday");
    let mondayTable = times.filter((data) => data.weekName === "Monday");
    let tuesdayTable = times.filter((data) => data.weekName === "Tuesday");
    let wednesdayTable = times.filter((data) => data.weekName === "Wednesday");
    let thursdayTable = times.filter((data) => data.weekName === "Thursday");
    let fridayTable = times.filter((data) => data.weekName === "Friday");
    let weekTable = times.filter((data) => data.weekName === this.state.day);
    return (
      <div>
        <div className={classes.sectionDesktop}>
          <div>Sunday</div>
          {sundayTable.length !== 0 ? (
            <Grid container spacing={3}>
              {sundayTable.map((timeData, index) => (
                <UserTeacherTimetableBody data={timeData} key={index} />
              ))}
            </Grid>
          ) : (
            <div
              style={{
                padding: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No routine for this day
            </div>
          )}
          <div>Monday</div>
          {mondayTable.length !== 0 ? (
            <Grid container spacing={3}>
              {mondayTable.map((timeData, index) => (
                <UserTeacherTimetableBody data={timeData} key={index} />
              ))}
            </Grid>
          ) : (
            <div
              style={{
                padding: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No routine for this day
            </div>
          )}
          <div>Tuesday</div>
          {tuesdayTable.length !== 0 ? (
            <Grid container spacing={3}>
              {tuesdayTable.map((timeData, index) => (
                <UserTeacherTimetableBody data={timeData} key={index} />
              ))}
            </Grid>
          ) : (
            <div
              style={{
                padding: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No routine for this day
            </div>
          )}
          <div>Wednesday</div>
          {wednesdayTable.length !== 0 ? (
            <Grid container spacing={3}>
              {wednesdayTable.map((timeData, index) => (
                <UserTeacherTimetableBody data={timeData} key={index} />
              ))}
            </Grid>
          ) : (
            <div
              style={{
                padding: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No routine for this day
            </div>
          )}
          <div>Thursday</div>
          {thursdayTable.length ? (
            <Grid container spacing={3}>
              {thursdayTable.map((timeData, index) => (
                <UserTeacherTimetableBody data={timeData} key={index} />
              ))}
            </Grid>
          ) : (
            <div
              style={{
                padding: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No routine for this day
            </div>
          )}
          <div>Friday</div>
          {fridayTable.length !== 0 ? (
            <Grid container spacing={3}>
              {fridayTable.map((timeData, index) => (
                <UserTeacherTimetableBody data={timeData} key={index} />
              ))}
            </Grid>
          ) : (
            <div
              style={{
                padding: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No routine for this day
            </div>
          )}
        </div>
        <div className={classes.sectionMobile}>
          <TextField
            name="day"
            select
            required
            fullWidth
            label="Day"
            variant="outlined"
            margin="normal"
            SelectProps={{ native: true }}
            style={{ marginRight: 10 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.day}
            onChange={(e) => this.setState({ day: e.target.value })}
          >
            <option value="">Select Any One</option>
            {week.map((week, index) => (
              <option value={week} key={index}>
                {week}
              </option>
            ))}
            <option value="Saturday">Saturday</option>
          </TextField>
          Current Day:{this.state.day}
          {weekTable.length !== 0 ? (
            <Grid container spacing={3}>
              {weekTable.map((timeData, index) => (
                <UserTeacherTimetableBody data={timeData} key={index} />
              ))}
            </Grid>
          ) : (
            <div
              style={{
                padding: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No routine for this day
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(UserTeacherTimetable);
